import Vue from 'vue';
//import moment from 'moment'

function currency(value) {
    let val = (value / 100).toFixed(2).replace('.', ',');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' €';
}

// function dateWithTime(value) {
//     return moment(value).format("LLLL") + ' Uhr';
// }


Vue.filter('currency', currency);
//Vue.filter('dateWithTime', dateWithTime);